import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    Input,
    Container,
    Card,
    CardGroup,
    CardContent,
    CardHeader,
    CardMeta,
    CardDescription,
    Form,
    FormField,
    Image,
} from 'semantic-ui-react';
import * as actions from './findUsersActions';
import { UsersContext } from '../Contexts/UsersContext';
import UserCard from './UserCard';

// TODO: create a seachable interface using semantic ui react
// TODO: complete the search user saga and wire to this interface
function FindUsers({ onSearchUsers, usersFound }) {
    const [searchText, setSearchText] = useState('');
    const changeText = ({ target }) => setSearchText(target.value);
    const searchUsers = () => onSearchUsers(searchText);

    // debounce the search input
    useEffect(() => {
        const timeoutId = setTimeout(searchUsers, 500);
        return () => clearTimeout(timeoutId);
    }, [searchText, 500]);

    return (
        <>
            <UsersContext.Provider value={{ users: usersFound }}>
                <Container>
                    <Form>
                        <FormField>
                            <Input
                                id='user-search-input'
                                placeholder='Search...'
                                style={{ width: '30%' }}
                                onChange={changeText}
                            />
                        </FormField>
                    </Form>
                    <CardGroup style={{ marginTop: '1em' }}>
                        {Object.keys(usersFound || {}).map((k) => (
                            <UserCard key={k} userId={k} />
                        ))}
                    </CardGroup>
                </Container>
            </UsersContext.Provider>
        </>
    );
}

// export default FindUsers;
const mapStateToProps = (
    state,
    {
        match: {
            params: { id },
        },
    }
) => {
    const usersFound = state?.findUsers?.usersFound;
    return {
        usersFound,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onSearchUsers: (args) => dispatch(actions.searchUsers(args)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(FindUsers);
